import { css } from 'styled-components';
import { WHITE, PURPLE_LIGHT, PINK } from '../../../constants/colors';
import { rem, media } from '../../../helpers/mixins';

export default {
  transparentbg: css`
    position: absolute;
    opacity: 0.75;
    width: 100%;
    height: 50%;
    bottom: 0;
    background-color: ${PURPLE_LIGHT};
    ${media.sm`
      width: 80%;
      height: 100%;
      left: -20%;
      transform: skewX(-10deg);
    `};
    ${media.md`
      width: 67%;
      left: -10%;
    `};
  `,
  pinkbg: css`
    position: absolute;
    width: 100%;
    height: 25px;
    top: 20%;
    background-color: ${PINK};
    opacity: 0.75;
    ${media.sm`
      width: 75%;
      height: 100%;
      left: -20%;
      top: 0;
      opacity: 1;
      transform: skewX(-10deg);
    `};
    ${media.md`
      width: 65%;
      left: -10%;
    `};
  `,
  innerwrapper: css`
    position: relative;
    width: 100%;
    height: 100%;
    padding: 40px 0px 135px 0px;

    ${media.sm`
      padding: 10vw 0px 15.5vw 0px;
    `}
    ${media.md`
      padding: 100px 0px 135px 0px;
    `};
  `,

  wrapper: css`
    display: flex;
    position: relative;
    overflow: hidden;
    flex-direction: column;
    flex: 1;
    margin-right: 5px;
    margin-left: 5px;
    padding-top: 21vh;
    height: 100%;
    ${media.switchHeaderToDesktop`
      margin: 0 0px;
      padding-left: 60px;
    `};
    ${media.sm`
      min-height: 60vh;
      width: 100%;
      padding-top: 0;
    `};
  `,
  itemWrapper: css`
    display: flex;
    width: 100%;
    padding: 8px;
    text-align: justify;
  `,
  title: ({ descriptionColor }) => css`
    font-size: ${rem('26px')};
    line-height: 1.2;
    color: ${PINK};
    padding-top: 0;
    padding-bottom: 0;
    text-align: left;
    margin-top: 48px;
    ${media.sm`
      color: ${descriptionColor};
      padding-top: 45px;
      padding-bottom: 56px;
    `};
    ${media.switchHeaderToDesktop`
      font-size: ${rem('40px')};
    `};
    ${media.lg`
      font-size: ${rem('54px')};
    `};
    ${media.xl`
      font-size: ${rem('74px')};
    `};
  `,
  description: ({ descriptionColor }) => css`
    font-size: ${rem('15px')};
    line-height: ${rem('20px')};
    color: ${descriptionColor};
    ${media.sm`
      font-size: ${rem('16px')};
      line-height: ${rem('20px')};
    `};
    ${media.lg`
      font-size: ${rem('25px')};
      line-height: ${rem('29px')};
    `};
    ${media.xl`
      font-size: ${rem('42px')};
      line-height: ${rem('51px')};
    `};
  `,
  terms: ({ descriptionColor }) => css`
    font-size: ${rem('16px')};
    color: ${descriptionColor};
    ${media.sm`
      font-size: ${rem('13px')};
      line-height: ${rem('20px')};
    `};
    ${media.lg`
      font-size: ${rem('16px')};
      line-height: ${rem('20px')};
    `};
    ${media.xl`
      font-size: ${rem('27px')};
      line-height: ${rem('39px')};
    `};

  `,
  callToActionWrapper: css`
    display: flex;
    flex: 1;
    align-items: flex-end;
    justify-content: flex-start;
    align-self: flex-start;
    padding-top: 64px;
    padding-bottom: 40px;
    width: 100%;
  `,
  more: css`
    color: ${PINK};
    word-break: break-word;
    padding: 0 8px;
    font-size: ${rem('32px')};

    &:hover {
      color: ${PINK};
      text-decoration: none;
      opacity: 0.8;
    }
  `,
  callToAction: css`
    color: ${PINK};
    word-break: break-word;
    padding: 0 8px;

    &:hover {
      color: ${PINK};
      text-decoration: none;
      opacity: 0.8;
    }
  `
};
